import React, { useState, useRef, useEffect } from "react";
import "./home.css";
import "./home.scss";
import Partner from "./Partner";
import Testimonial from "./Testimonial";
import PauseOnHover from "./CardSlider/CardSlider";
import BannerCarousel from "../BannerCarousel/BannerCarousel";
import HexaShop from "./HexaShop";
import CalendarComponent from "./calender/components/Calendar";
import EventSection from "./calender/components/EventSection";
import { Link } from "react-router-dom";
import CanVisitSection from "./CanVisitSection";
// import headerBackgroundImage from './header2.png';

function Home() {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const images1 = [
    "image/banner/banner2.png",
    "image/banner/banner11.jpg",
    "image/banner/banner3.png",
  ];

  const images2 = [
    "image/home/landmark-event.jpg",
    "image/home/landmark-events.jpg",
    "image/home/legacy-2.jpg",
    "image/home/publications-.jpg",
    "image/home/nirankari-samagams.jpg",
  ];

  return (
    <div>
      <div className="relative ">
        <div className="">
          <BannerCarousel images={images1} />
        </div>
        <div className="absolute left-0 w-full lg:top-[38%]">
          <div className="flex justify-center">
            {/* <div className='h-[1px] my-auto w-16 bg-blue-400'></div> */}
            <div className="w-[90%] animate-bounce text-center flex items-center font-serif text-xl tracking-widest text-gray-900 bg-slate-100 rounded-lg pt-7 pb-2 justify-center flex-col shadow-lg">
              Sant Nirankari Mandal Delhi(Regd.) Branch Sangli
              <img
                src="./image/visitus.png"
                width={400}
                className="text-blue-900"
              />
            </div>
            {/* <div className='h-[1px] my-auto w-16 bg-blue-400'></div> */}
          </div>
        </div>
        <div className="pb-4">
          <h2 className=" border-b-2 border-[gainsboro] w-[25%] mx-auto items-center flex-col lg:mt-20 justify-center font-serif text-center text-blue-800 text-[26px] rounded-2xl">                      
            YOU CAN VISIT US            
          </h2>
          {/* <div className="grid grid-cols-1 lg:grid-cols-3 lg:mx-[50px]">
            <div className="col-span-1">
              <div className="">
                <h3 className='font-sans text-3xl text-center border-b-2 '>You Can Visit</h3>
                <ul>
                  <Link to="/ideology" className="">
                    <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white">
                      <img src="./image/1Ideology.png" width={30} className="bg-white rounded-full"/>
                      Ideology
                    </li>
                  </Link>
                  <Link to="/lagacy">
                    <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white">
                      <img src="./image/2legacy.png" width={30} className="bg-white rounded-full"/>
                      Lagacy
                    </li>
                  </Link>
                  <Link to="/spirituality">
                    <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white">
                      <img src="./image/3Sprituality.png" width={30}  className="bg-white rounded-sm"/>
                      Practical Sprituality
                    </li>
                  </Link>
                  <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white">
                    <img src="./image/4GlobalMission.png" width={30} className="bg-white rounded-sm"/>
                    Global Mission
                  </li>
                  <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white">
                    <img src="./image/5world.png" width={30} className="bg-white rounded-sm"/>
                    Nirankari Samangam
                  </li>
                  <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white ">
                    <img src="./image/6CommunityService.png" width={30} className="bg-white rounded-sm"/>
                    Community Service
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-span-1 m-6">
              <div className="mx-auto ">
                <BannerCarousel images={images2} className="rounded-2xl" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="">
                <ul>
                  <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white">
                    <img src="./image/7Landmark.png" width={30} className="bg-white rounded-sm"/>
                    Landmark Event
                  </li>
                 
                  <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white">
                    <img src="./image/8news.png" width={30} className="bg-white rounded-sm"/>
                    News
                  </li>
                  <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white">
                    <img src="./image/9studio.png" width={30} className="bg-white rounded-sm"/>
                    Studio Devine
                  </li>
                  <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white">
                    <img src="./image/10music.png" width={30} className="bg-white rounded-sm"/>
                    Music
                  </li>
                  <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white">
                    <img src="./image/11podcast.png" width={30} className="bg-white rounded-sm"/>
                    Podcast
                  </li>
                  <li className="flex items-center gap-4 py-3 pl-10 font-sans text-xl font-semibold border-b-2 rounded-lg cursor-pointer hover:bg-blue-900 hover:text-white ">
                    <img src="./image/12Publication.png" width={30} className="bg-white rounded-sm"/>
                    Publication
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
          <CanVisitSection/>
        </div>
      </div>
      <h2 className=" border-b-2 border-[gainsboro] w-[35%] mx-auto items-center flex-col justify-center font-serif text-center text-blue-800 text-[26px] rounded-2xl">            
            {/* <div className="h-[2px] my-auto mx-2 w-20 bg-blue-800 inline-block"></div> */}
            Discover Our Upcoming Events
            {/* <div className="h-[2px] my-auto w-20 bg-blue-800 inline-block mx-2"></div> */}
          </h2>
      {/* <h3 className="mt-2 rounded-full p-2 w-[65%] mx-auto font-serif text-center text-blue-800 text-2xl bg-[aliceblue] uppercase">      
      <div className="h-[2px] my-auto mx-2 w-20 bg-blue-800 inline-block"></div>
      Discover Our Upcoming Events
            <div className="h-[2px] my-auto w-20 bg-blue-800 inline-block mx-2"></div>
      </h3> */}
      <div className="gap-5 pt-4 pb-10 lg:flex justify-between lg:mx-10">
        <div className="">
          <CalendarComponent onDateChange={handleDateChange} />
        </div>
        <div className="flex justify-center w-full pt-4 mx-auto shadow-lg hover:shadow-xl xs:mt-10 bg-slate-50 rounded-xl ">
          <EventSection selectedDate={selectedDate} />
        </div>
      </div>
    </div>
  );
}

export default Home;
